import React, { useEffect, useState } from "react";
import { PhoneCall, X } from "lucide-react";

const KEY = "lgw_crisis_dismissed";

export default function CrisisBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem(KEY);
    if (!dismissed) setShow(true);
  }, []);

  if (!show) return null;

  return (
    <div
      role="region"
      aria-label="Crisis support"
      data-testid="crisis-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] bg-[#9F5C45] text-[#FDFBF7] border-t border-[#FDFBF7]/20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-3 flex items-center justify-between gap-4 text-sm">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <PhoneCall className="w-4 h-4 shrink-0" strokeWidth={1.5} />
          <p className="leading-relaxed">
            <strong className="font-medium">In crisis right now?</strong>{" "}
            <span className="opacity-90">
              You're not alone. Call or text{" "}
              <a href="tel:988" data-testid="crisis-988-link" className="underline underline-offset-4 hover:opacity-100">
                988
              </a>{" "}
              — the Suicide &amp; Crisis Lifeline. Free, confidential, 24/7.
            </span>
          </p>
        </div>
        <button
          onClick={() => {
            sessionStorage.setItem(KEY, "1");
            setShow(false);
          }}
          aria-label="Dismiss crisis banner"
          data-testid="crisis-dismiss"
          className="p-2 hover:bg-[#FDFBF7]/10 transition-colors shrink-0"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
